import { Container, Divider, Spacer } from '@cleartrip/ct-design-components'
import { Stencil } from '@/components/common/Stencil'
import React, { memo } from 'react'

const LoaderCard = memo(() => (
    <Container className="mb-4">
        <Container className="br-16 pt-4 w-100p" css={{ border: 'solid 1px #e6e6e6' }}>
            <Container className="flex px-4">
                <Container>
                    <Stencil shimmer height="32px" width="32px" className="br-8" />
                    <Spacer className="mb-1" />
                    <Stencil shimmer height="14px" width="62px" className="br-2" />
                    <Spacer className="mb-1" />
                    <Stencil shimmer height="14px" width="62px" className="br-2" />
                </Container>
                <Spacer className="ml-6" />
                <Stencil shimmer height="45px" width="316px" className="br-2" />
            </Container>
            <Divider borderColor="#E6E6E6" className="mt-2" />
            <Container className="px-4 py-3" css={{ borderBottomLeftRadius: '15px', borderBottomRightRadius: '15px' }}>
                <LoaderSegment />
                <Container className="px-2 my-3">
                    <Divider borderColor="#E6E6E6" borderStyle="dotted" />
                </Container>
                <LoaderSegment />
            </Container>
        </Container>
        <Container
            backgroundColor="#F3F3F3"
            className="h-8 mx-4 flex flex-center flex-middle"
            css={{ borderBottomLeftRadius: '12px', borderBottomRightRadius: '12px' }}
        >
            <Stencil shimmer height="16px" width="134px" className="br-8" />
        </Container>
    </Container>
))

const LoaderSegment = memo(() => (
    <Container className="flex flex-between">
        <Container className="o-hidden">
            <Stencil shimmer height="20px" width="150px" className="br-2" />
        </Container>
        <Container className="pl-6 flex flex-column flex-between">
            <Container className="flex flex-baseline flex-right mb-1">
                <Stencil shimmer height="24px" width="69px" className="br-2" />
            </Container>
            <Stencil shimmer height="14px" width="43px" className="br-2" />
        </Container>
    </Container>
))

function RoundTripTuppleLoader() {
    return (
        <Container className="flex-1 flex mt-6">
            <Container className="w-50p pr-2">
                <LoaderCard />
                <LoaderCard />
                <LoaderCard />
            </Container>
            <Container className="w-50p pl-3">
                <LoaderCard />
                <LoaderCard />
                <LoaderCard />
            </Container>
        </Container>
    )
}

export default RoundTripTuppleLoader
